module.exports = __webpack_public_path__ + "img/logo_financiera.9ac57aa7.png";